function isObject (o) {
  return typeof o === 'object' && o !== null
}

export default isObject
